import { useEffect, useState } from 'react';
import { listExperts } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useExperts(practice_area = '') {
  const [List, setList] = useState([]);

  const loadExperts = () => {
    totalCountEvent('expert_type').then((response) => {
      listExperts(response.data, '', 'forward', false, practice_area).then((res) => {
        setList(res.data?.experts);
      });
    });
  };

  useEffect(() => {
    loadExperts();
  }, [practice_area]);

  return { expertList: List };
}
